import PropTypes from 'prop-types'
import { Box, CircularProgress } from '@mui/material'

const styles = {
  spinner: {
    width: '100%',
    marginTop: '24px',
    marginBottom: '24px',
    display: 'flex',
    justifyContent: 'center',
    alignContent: 'center',
    alignItems: 'center',
  },
  fullWidthSpinner: {
    position: 'absolute',
    top: 0,
    bottom: 0,
    left: 0,
    right: 0,
    margin: 'auto',
    zIndex: 1,
    display: 'flex',
    justifyContent: 'center',
    alignContent: 'center',
    alignItems: 'center',
  },
}

function Spinner(props) {
  let style: any = props.fullWidth ? { ...styles.fullWidthSpinner } : { ...styles.spinner }
  style = { ...style, ...props.style }
  return (
    <Box sx={styles}>
      <div style={style}>
        <CircularProgress color={props.color} size={props.size} />
      </div>
    </Box>
  )
}

Spinner.defaultProps = {
  fullWidth: false,
  color: 'primary',
  className: '',
  size: 40,
  style: {},
}

Spinner.propTypes = {
  fullWidth: PropTypes.bool,
  color: PropTypes.string,
  className: PropTypes.string,
  size: PropTypes.number,
  style: PropTypes.object,
}

export default Spinner
